import {
	httpBatchStreamLink,
	httpLink,
	httpSubscriptionLink,
	loggerLink,
	splitLink,
	type TRPCLink,
} from '@trpc/client';
import SuperJSON from 'superjson';
import { getDevSettingSync } from '@/components/features/dev-menu/config';
import type { AppRouter } from '@/server/root';
import { getUrl } from '../utils/app-env';

export const trpcLinks: TRPCLink<AppRouter>[] = [
	loggerLink({
		enabled: () => getDevSettingSync('queryLogger'),
	}),
	splitLink({
		condition: (op) => op.type === 'subscription',
		true: httpSubscriptionLink({
			transformer: SuperJSON,
			url: getUrl('/api/rpc'),
		}),
		false: splitLink({
			condition: () => getDevSettingSync('disableBatching'),
			true: httpLink({
				transformer: SuperJSON,
				url: getUrl('/api/rpc'),
				headers: () => {
					const headers = new Headers();
					headers.set('x-trpc-source', 'tanstack-start');
					return headers;
				},
			}),
			false: httpBatchStreamLink({
				transformer: SuperJSON,
				url: getUrl('/api/rpc'),
				headers: () => {
					const headers = new Headers();
					headers.set('x-trpc-source', 'tanstack-start');
					return headers;
				},
			}),
		}),
	}),
];
